'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _activeErrorModalIdReducer = require('./activeErrorModalIdReducer');

var _activeErrorModalIdReducer2 = _interopRequireDefault(_activeErrorModalIdReducer);

var _errorModalDataReducer = require('./errorModalDataReducer');

var _errorModalDataReducer2 = _interopRequireDefault(_errorModalDataReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxImmutable.combineReducers)({
    activeModalId: _activeErrorModalIdReducer2.default,
    data: _errorModalDataReducer2.default
}); // Lib


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/errorModalReducer.js
// module id = 1770
// module chunks = 0